<div class="header-wrapper">
  <app-apps-info> </app-apps-info>
  <!-- Header Tabs -->
  <mat-tab-group (selectedIndexChange)="onChangeTab($event)" class="tab-width" animationDuration="0ms">
    @for (tab of tabs; track tab) {
    <mat-tab [label]="tab.name">
    </mat-tab>
    }
  </mat-tab-group>
  <mat-card>
    <mat-card-content>
    @if (selectedTab?.id === 0) {
    <app-app-users
      class="mat-elevation-z24"
      [rolesSub]="rolesSub"
      ></app-app-users>
    }
    @if (selectedTab.id === 1) {
    <app-apps-roles
      [rolesSub]="rolesSub"
    ></app-apps-roles>
    }
  </mat-card-content>
  </mat-card>

</div>

@if (_appsService?.loading) {
<app-spinner></app-spinner>
}
